// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Card container */
.irrigation-card {
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  border-radius: 4px;
  background: var(--color-grey-100);
  background: var(--color-grey-100);
  min-height: 144px;
  width: 100%;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
}

.irrigation-card__header {
  font-size: 16px;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 700;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-bottom: 1px solid var(--color-grey-91);
  border-bottom: 1px solid var(--color-grey-91);
  padding: 8px 0;
  height: 32px;
}

.irrigation-card__date {
  font-size: 14px;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  margin-left: 8px;
}

.irrigation-card__stats-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 112px;
  padding: 0 0 0 0;
  height: 100%;
}

.irrigation-card__stat-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  flex: 1;
}

.irrigation-card__stat-label {
  font-size: 14px;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  margin-bottom: 0;
  line-height: 1.2;
  text-align: center;
}

.irrigation-card__stat-value {
  font-size: 32px;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 700;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  line-height: 1.25em;
  text-align: center;
}

.irrigation-card__stat-unit {
  font-size: 14px;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  text-align: center;
}

.irrigation-card__divider {
  width: 1px;
  height: 80px;
  background: var(--color-grey-91);
  background: var(--color-grey-91);
  margin: 0 16px;
  align-self: center;
}

.irrigation-card__no-planning-message {
  font-size: 18px;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  color: var(--color-grey-71);
  color: var(--color-grey-71);
  line-height: 1.33;
  text-align: center;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.irrigation-card__arrow {
  background: none;
  border: none;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  font-size: 24px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  box-sizing: border-box;
}

/* Add transparent borders by default to prevent layout shift on hover */
.irrigation-card__arrow:first-child {
  border-right: 1px solid transparent;
}

.irrigation-card__arrow:last-child {
  border-left: 1px solid transparent;
}

.irrigation-card__arrow:hover:not(:disabled) {
  background: var(--color-grey-96);
  background: var(--color-grey-96);
  height: 112px;
}

/* Left arrow - border only on the right (inward) */
.irrigation-card__arrow:first-child:hover:not(:disabled) {
  border-right: 1px solid var(--color-grey-91);
  border-right: 1px solid var(--color-grey-91);
  border-bottom-left-radius: 3px; /* border-radius: 3px 0 0 3px; */
}

/* Right arrow - border only on the left (inward) */
.irrigation-card__arrow:last-child:hover:not(:disabled) {
  border-left: 1px solid var(--color-grey-91);
  border-left: 1px solid var(--color-grey-91);
  border-bottom-right-radius: 3px; /* border-radius: 0 3px 3px 0; */
}
.irrigation-card__arrow:first-child {
  margin-left: 0;
}
.irrigation-card__arrow:last-child {
  margin-right: 0;
}
.irrigation-card__arrow:disabled {
  color: var(--color-disabled-85);
  color: var(--color-disabled-85);
  cursor: default;
}
.irrigation-card__arrow img {
  filter: none;
  transition: filter 0.2s;
}
.irrigation-card__arrow:disabled img {
  filter: grayscale(1) brightness(1.7) contrast(0.8);
}

@media (max-width: 1560px) {
  .irrigation-card {
    height: 258px;
  }

  .irrigation-card__arrow:hover:not(:disabled) {
    height: 224px;
  }
}

.irrigation-card__stats-row--disabled {
  /* All text in the stats row should use disabled-64 color */
}
.irrigation-card__stats-row--disabled .irrigation-card__stat-label,
.irrigation-card__stats-row--disabled .irrigation-card__stat-value,
.irrigation-card__stats-row--disabled .irrigation-card__stat-unit {
  color: var(--color-disabled-64);
  color: var(--color-disabled-64);
}
`, "",{"version":3,"sources":["webpack://./app/components/planning/IrrigationRecommendation/IrrigationRecommendationCard.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,kBAAkB;EAClB,iCAAiC;EAAjC,iCAAiC;EACjC,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAA3B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6CAA6C;EAA7C,6CAA6C;EAC7C,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAA3B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,OAAO;AACT;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAA3B,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAA3B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gCAAgC;EAAhC,gCAAgC;EAChC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAA3B,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAA3B,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,wEAAwE;AACxE;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAAhC,gCAAgC;EAChC,aAAa;AACf;;AAEA,mDAAmD;AACnD;EACE,4CAA4C;EAA5C,4CAA4C;EAC5C,8BAA8B,EAAE,gCAAgC;AAClE;;AAEA,mDAAmD;AACnD;EACE,2CAA2C;EAA3C,2CAA2C;EAC3C,+BAA+B,EAAE,gCAAgC;AACnE;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,+BAA+B;EAA/B,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,kDAAkD;AACpD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,2DAA2D;AAC7D;AACA;;;EAGE,+BAA+B;EAA/B,+BAA+B;AACjC","sourcesContent":["/* Card container */\n.irrigation-card {\n  border: 1px solid var(--color-grey-91);\n  border-radius: 4px;\n  background: var(--color-grey-100);\n  min-height: 144px;\n  width: 100%;\n  min-width: 400px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  box-sizing: border-box;\n}\n\n.irrigation-card__header {\n  font-size: 16px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 700;\n  color: var(--color-grey-45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  border-bottom: 1px solid var(--color-grey-91);\n  padding: 8px 0;\n  height: 32px;\n}\n\n.irrigation-card__date {\n  font-size: 14px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 400;\n  color: var(--color-grey-45);\n  margin-left: 8px;\n}\n\n.irrigation-card__stats-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  min-height: 112px;\n  padding: 0 0 0 0;\n  height: 100%;\n}\n\n.irrigation-card__stat-block {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 80px;\n  flex: 1;\n}\n\n.irrigation-card__stat-label {\n  font-size: 14px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 400;\n  color: var(--color-grey-45);\n  margin-bottom: 0;\n  line-height: 1.2;\n  text-align: center;\n}\n\n.irrigation-card__stat-value {\n  font-size: 32px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 700;\n  color: var(--color-grey-45);\n  line-height: 1.25em;\n  text-align: center;\n}\n\n.irrigation-card__stat-unit {\n  font-size: 14px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 400;\n  color: var(--color-grey-45);\n  text-align: center;\n}\n\n.irrigation-card__divider {\n  width: 1px;\n  height: 80px;\n  background: var(--color-grey-91);\n  margin: 0 16px;\n  align-self: center;\n}\n\n.irrigation-card__no-planning-message {\n  font-size: 18px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 400;\n  color: var(--color-grey-71);\n  line-height: 1.33;\n  text-align: center;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.irrigation-card__arrow {\n  background: none;\n  border: none;\n  color: var(--color-grey-45);\n  font-size: 24px;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n/* Add transparent borders by default to prevent layout shift on hover */\n.irrigation-card__arrow:first-child {\n  border-right: 1px solid transparent;\n}\n\n.irrigation-card__arrow:last-child {\n  border-left: 1px solid transparent;\n}\n\n.irrigation-card__arrow:hover:not(:disabled) {\n  background: var(--color-grey-96);\n  height: 112px;\n}\n\n/* Left arrow - border only on the right (inward) */\n.irrigation-card__arrow:first-child:hover:not(:disabled) {\n  border-right: 1px solid var(--color-grey-91);\n  border-bottom-left-radius: 3px; /* border-radius: 3px 0 0 3px; */\n}\n\n/* Right arrow - border only on the left (inward) */\n.irrigation-card__arrow:last-child:hover:not(:disabled) {\n  border-left: 1px solid var(--color-grey-91);\n  border-bottom-right-radius: 3px; /* border-radius: 0 3px 3px 0; */\n}\n.irrigation-card__arrow:first-child {\n  margin-left: 0;\n}\n.irrigation-card__arrow:last-child {\n  margin-right: 0;\n}\n.irrigation-card__arrow:disabled {\n  color: var(--color-disabled-85);\n  cursor: default;\n}\n.irrigation-card__arrow img {\n  filter: none;\n  transition: filter 0.2s;\n}\n.irrigation-card__arrow:disabled img {\n  filter: grayscale(1) brightness(1.7) contrast(0.8);\n}\n\n@media (max-width: 1560px) {\n  .irrigation-card {\n    height: 258px;\n  }\n\n  .irrigation-card__arrow:hover:not(:disabled) {\n    height: 224px;\n  }\n}\n\n.irrigation-card__stats-row--disabled {\n  /* All text in the stats row should use disabled-64 color */\n}\n.irrigation-card__stats-row--disabled .irrigation-card__stat-label,\n.irrigation-card__stats-row--disabled .irrigation-card__stat-value,\n.irrigation-card__stats-row--disabled .irrigation-card__stat-unit {\n  color: var(--color-disabled-64);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
